var version = {
    "name":      "dativery",
    "buildDateCode": "20260415-163032",
    "buildDate": "Wed Apr 15 2026 16:30:32 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260415-163032",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;